export const horses = {
  noneFound: 'No horses found',
  nav: {
    stallion: 'Stallions',
    stud: 'Studs',
    mare: 'Mares',
    surrogate: 'Surrogates',
  },
};
